// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"8":"a0095b69","71":"d44b79e0","427":"9996615a","458":"b987316a","508":"c7482f8e","893":"2e2a0690","994":"d72efde0"}[chunkId] + ".css";
};